import { onDocumentReady } from '../utils/events';

/**
 * Swaps the clinical-study mockup image on the Study contact form to match the
 * product the visitor selects. Matches the Gravity Forms image choice by its
 * visible label, so it is resilient to the field's internal choice values.
 */
onDocumentReady(() => {
  const media = document.querySelector('[data-clinical-media]');
  if (!media) return;

  const slides = Array.from(
    media.querySelectorAll('.contact-study-mockup__slide')
  );
  if (slides.length < 2) return; // nothing to swap between

  const KEYWORDS = {
    nctf: 'nctf',
    'art-filler': 'art fil', // matches "Art Filler" or the current "Art Filter"
    micronjet: 'micronjet',
    pliaglis: 'pliaglis',
  };

  const show = (key) => {
    const target =
      slides.find((s) => s.dataset.clinical === key) ||
      slides.find((s) => s.dataset.clinical === 'default') ||
      slides[0];
    slides.forEach((s) => s.classList.toggle('is-active', s === target));
  };

  const update = () => {
    const checked = Array.from(
      document.querySelectorAll('.gchoice input:checked')
    );
    if (!checked.length) {
      show('default');
      return;
    }
    // Use the most recently interacted choice (last in DOM order that is checked).
    const label = (
      checked[checked.length - 1].closest('.gchoice')?.textContent || ''
    ).toLowerCase();
    const key = Object.keys(KEYWORDS).find((k) => label.includes(KEYWORDS[k]));
    show(key || 'default');
  };

  document.addEventListener('change', (event) => {
    if (event.target.closest && event.target.closest('.gchoice')) update();
  });

  // Reflect any pre-selected product (e.g. arriving from a brand page).
  let tries = 0;
  const timer = window.setInterval(() => {
    if (document.querySelector('.gchoice')) {
      update();
      window.clearInterval(timer);
    } else if ((tries += 1) > 20) {
      window.clearInterval(timer);
    }
  }, 150);
});
